import { store } from "../Store/store";
let langData = require("../Data/language.json");

export default function displayDate(date) {
  const monthNamesEnglish = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let language = store.getState().firebase.language;
  let itemDate = new Date(date);
  let month = monthNamesEnglish[itemDate.getMonth()];
  let displayDate = langData[language].months[month] + " " + itemDate.getDate();

  return displayDate;
}
